/* tslint:disable */
/* eslint-disable */
/**
 * Autom8.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import {Project, ProjectFromJSON, ProjectToJSON,} from './Project';

/**
 *
 * @export
 * @interface ProjectIReadOnlyCollectionApiResult
 */
export interface ProjectIReadOnlyCollectionApiResult {
    /**
     *
     * @type {boolean}
     * @memberof ProjectIReadOnlyCollectionApiResult
     */
    success?: boolean;
    /**
     *
     * @type {Array<Project>}
     * @memberof ProjectIReadOnlyCollectionApiResult
     */
    content?: Array<Project> | null;
    /**
     *
     * @type {string}
     * @memberof ProjectIReadOnlyCollectionApiResult
     */
    message?: string | null;
}

export function ProjectIReadOnlyCollectionApiResultFromJSON(json: any): ProjectIReadOnlyCollectionApiResult {
    return ProjectIReadOnlyCollectionApiResultFromJSONTyped(json, false);
}

export function ProjectIReadOnlyCollectionApiResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectIReadOnlyCollectionApiResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'success': !exists(json, 'success') ? undefined : json['success'],
        'content': !exists(json, 'content') ? undefined : (json['content'] === null ? null : (json['content'] as Array<any>).map(ProjectFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function ProjectIReadOnlyCollectionApiResultToJSON(value?: ProjectIReadOnlyCollectionApiResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'success': value.success,
        'content': value.content === undefined ? undefined : (value.content === null ? null : (value.content as Array<any>).map(ProjectToJSON)),
        'message': value.message,
    };
}

